import React, { FunctionComponent } from "react";

import { AggregationFunction } from "@multiweb/clients/dataReader";
import { TextButtonSelect } from "@multiweb/reactComponents";
import { Option } from "@multiweb/types/react";

export type AggregationSelectComponentProps = {
    /** Vybraná hodnota */
    value?: AggregationFunction;
    /** Funkce volaná po výběru hodnoty */
    onChange: (value?: AggregationFunction) => void;
    /** Možnosti rozevíracího seznamu */
    options: ReadonlyArray<Option<AggregationFunction>>;
    /** Popisek pro rozevírací textové tlačítko */
    title?: string;
    /** Text rozevíracího tlačítka před vybráním hodnoty */
    defaultText?: string;
};

/** Komponenta slouží pro výběr agregační funkce pomocí rozevíracího seznamu. */
export const AggregationSelectComponent: FunctionComponent<AggregationSelectComponentProps> = ({
    value,
    onChange,
    options,
    defaultText,
    title,
}) => (
    <TextButtonSelect<AggregationFunction>
        {...{ value, onChange, options, title, defaultText }}
    />
);
